module.exports = __webpack_public_path__ + "static/media/washerly_icon.1542793e.png";